import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import SectionHeading from "@/components/base/SectionHeading";

export default function CategoryGrid() {
  return (
    <section className="max-w-[1200px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <SectionHeading
        title="剧集分类快捷入口"
        subtitle="按题材快速找到你感兴趣的类型"
      />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {categories.map((c) => (
          <Link
            key={c.type}
            to={`/category/${c.type}`}
            className="group flex flex-col items-center text-center gap-3 p-4 md:p-5 bg-background-50 rounded-lg border border-background-200 hover:border-primary-300 hover:-translate-y-0.5 transition-all cursor-pointer"
          >
            <span className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-2xl group-hover:bg-primary-600 group-hover:text-background-50 transition-colors">
              <i className={c.icon} />
            </span>
            <span className="font-heading text-sm md:text-base font-semibold text-foreground-900">
              {c.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}